import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { selectNowNextByChannelId } from 'store/programs/selectors';

import fetchLiveProgram from 'utils/fetchLiveProgram';

import { isLiveEpgProgram } from 'screens/Epg/utils/program';

function useGetLiveProgram() {
    const nowNextByChannelId = useSelector(selectNowNextByChannelId);

    return useCallback(
        async (channelId: string) => {
            const liveProgram =
                nowNextByChannelId[channelId]?.find(isLiveEpgProgram);

            if (!liveProgram) {
                return fetchLiveProgram(channelId);
            }

            return liveProgram;
        },
        [nowNextByChannelId],
    );
}

export default useGetLiveProgram;
